import React, {createContext, ReactNode, useContext, useState} from 'react';
import {Font} from './components/CardEditor/types';

type RecentlyUsedFontsContextType = {
  recentlyUsedFonts: Font[];
  updateRecentlyUsedFont: (font: Font) => void;
  selectedCategories?: string[];
  setSelectedCategories?: React.Dispatch<React.SetStateAction<string[]>>;
  categoryFonts?: Record<string, Font[]>;
  setCategoryFonts?: React.Dispatch<React.SetStateAction<Record<string, Font[]>>>;
};

const RecentlyUsedFontsContext = createContext<RecentlyUsedFontsContextType | undefined>(undefined);

type ProviderProps = {
  children: ReactNode;
};

export const FontProvider = ({children}: ProviderProps) => {
  const [recentlyUsedFonts, setRecentlyUsedFonts] = useState<Font[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [categoryFonts, setCategoryFonts] = useState({});

  const updateRecentlyUsedFont = (font: Font) => {
    setRecentlyUsedFonts((prev) => {
      const filtered = prev.filter((prevFont) => {
        return (
          prevFont.family !== font.family ||
          prevFont.style !== font.style ||
          prevFont.weight !== font.weight
        );
      });
      return [font, ...filtered].slice(0, 3);
    });
  };

  return (
    <RecentlyUsedFontsContext.Provider
      value={{
        recentlyUsedFonts,
        updateRecentlyUsedFont,
        selectedCategories,
        setSelectedCategories,
        categoryFonts,
        setCategoryFonts,
      }}
    >
      {children}
    </RecentlyUsedFontsContext.Provider>
  );
};

export const useRecentlyUsedFonts = () => {
  const context = useContext(RecentlyUsedFontsContext);
  if (!context) {
    throw new Error('useRecentlyUsedFonts must be used within a FontProvider');
  }
  return context;
};
